import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import Page from 'ui/page'
import ourStory from 'goforajourney/img/our-story'
import ourPassion from 'goforajourney/img/our-passion'
import ourExperiencies from 'goforajourney/img/our-experiencies'
import ourProfessionals from 'goforajourney/img/our-professionals'

const AboutUs = (props) => {
  return (
    <Page {...props}>
      <div className="mb-5">
        <h1 className="mb-3 fw-bold">About GoforaJourney</h1>

        {/* --- Our Story --- */}
        <div className="d-flex align-items-center border rounded-3 p-3 my-5" style={{ fontSize: '1.1em' }}>
          <Row>
            <Col xs="12" md="6" className="order-first order-md-last">
              <img
                className="rounded-3"
                alt="Goforajourney Our Story"
                src={ourStory}
                width="100%"
                height="100%"
              />
            </Col>
            <Col className="align-self-center mt-3 mt-md-0 order-first">
              <h2 className="mb-3 fw-bold h3">Our Story</h2>
              <p>
                GoforaJourney was born from a shared passion: the joy of dedicating time to what truly moves
                us. We are a team of enthusiasts and experts who believe that our free time, our hobbies, and
                our dreams deserve more space and a little more magic.
              </p>
              <p>
                Many of us behind this project spent years in industries where profit margins and brand
                guidelines came before passion. This is our way of doing things differently, of doing what we
                love and in the way we love it.
              </p>
              <p>
                That’s why our experiences aren’t simply based on what we like. They’re designed and curated
                in collaboration with local guides, chefs, critics, scholars, and cultural insiders: people who live
                and breathe their craft.
              </p>
            </Col>
          </Row>
        </div>

        {/* --- Our Passion --- */}
        <div className="border rounded-3 p-3 my-5" style={{ fontSize: '1.1em' }}>
          <Row>
            <Col xs="12" md="6" className="order-first">
              <img
                className="rounded-3"
                alt="Goforajourney Our Passion"
                src={ourPassion}
                width="100%"
                height="100%"
              />
            </Col>            
            <Col xs="12" md="6" className="align-self-center mt-3 mt-md-0 order-last">
              <h2 className="mb-3 h3 fw-bold">Our Passion</h2>
              <p>
                We design and curate experiences, retreats, and journeys structured around specific passions:
                from gastronomy and culture to painting and flamenco. Every GoforaJourney activity is an
                invitation to dive deeper into what excites and inspires you.
              </p>
              <p>
                It’s not just about the places, it’s also about the people. We’ve found our community in those
                who see travel and exploration as a way to grow, connect, and rekindle curiosity.
              </p>
              <p>
                But we’re not stopping there. Our goal is to build a hub: a space for hobbyists, creatives, and
                professionals to learn, share, and create. In the coming years, we’ll launch a digital platform
                where workshops, collaborations, seminars, and marketplaces will bring passions to life. We’ll
                keep you posted as it unfolds.
              </p>
            </Col>
          </Row>
        </div>

        {/* --- Our Experiences --- */}
        <div className="border rounded-3 p-3 my-5" style={{ fontSize: '1.1em' }}>
          <Row>
            <Col xs="12" md="6" className="order-first order-md-last">
              <img
                className="rounded-3"
                alt="Goforajourney Our Experiences"
                src={ourExperiencies}
                width="100%"
                height="100%"
              />
            </Col>
            <Col xs="12" md="6" className="align-self-center mt-3 mt-md-0 order-first">
              <h2 className="mb-3 h3 fw-bold">Our Experiences</h2>
              <p>
                We offer premium cultural and gastronomic tours in some of the world’s most iconic
                destinations. Each experience combines world-class landmarks with local flavor, literally and
                culturally.
              </p>
              <p>
                Led by expert local guides and curated by award-winning chefs, cultural insiders, and
                storytellers, our small-group and private tours go far beyond the usual tourist trail. We focus on
                immersion, connection, and the kind of experiences that stay with you long after the journey
                ends.
              </p>
              <div className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  className="p-3 fw-medium rounded-3"
                  href="/web/barcelona-tours"
                >
                  Find Out More
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        {/* --- Our Professionals --- */}
        <div className="border rounded-3 p-3 my-5" style={{ fontSize: '1.1em' }}>
          <Row>
            <Col xs="12" md="6" className="order-first">
              <img
                className="rounded-3"
                alt="Goforajourney Our Professionals"
                src={ourProfessionals}
                width="100%"
                height="100%"
              />
            </Col>            
            <Col xs="12" md="6" className="align-self-center mt-3 mt-md-0 order-last">
              <h2 className="mb-3 h3 fw-bold">Our Professionals</h2>
              <p>
                Our guides shape the experience. Each one is chosen not just for their expertise, but for their
                ability to share a place through stories and real local insights. We collaborate closely with them
                to craft experiences that feel personal, thoughtful, and unique to the destination.
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </Page>
  )
}

export default AboutUs